import classNames from "classnames";
import { capitalizeAndRemoveDot } from "Services/common";
import { html } from "lit-html";
import { TemplateResult } from "lit-html";
import i18next from "i18next";
import dayjs from "dayjs";

export interface DateSelectorInputsDto {
	departureDate: dayjs.Dayjs | undefined;
	isOneWay: boolean;
	isSelectingReturn: boolean;
	returnDate: dayjs.Dayjs | undefined;
	onSelectDeparture: () => void;
	onSelectReturn: () => void;
}

export const mobileDateSelectorInputsTemplate = (dto: DateSelectorInputsDto): TemplateResult => html`
	<div class="mb-4 flex items-center gap-2">
		<div
			class=${classNames("flex-1 rounded-lg", {
				"p-[2px] bg-[#bfdeff]": !dto.isSelectingReturn,
			})}
			@click=${dto.onSelectDeparture}
		>
			<input
				readonly
				class=${classNames(
					"w-full cursor-default rounded-lg border border-solid px-3 py-[5px] text-base outline-hidden bg-white",
					"placeholder:text-base/none placeholder:text-[#c1c1c1]",
					{
						"border-[#7D93B2] border-2 text-n-blue": !dto.isSelectingReturn,
						"border-n-blue text-n-blue": dto.isSelectingReturn && dto.departureDate,
						"border-[#c1c1c1] text-[#c1c1c1]": dto.isSelectingReturn && !dto.departureDate,
					}
				)}
				placeholder=${i18next.t("Fecha Ida")}
				value=${dto.departureDate ? capitalizeAndRemoveDot(dto.departureDate.format("ddd DD-MM")) : ""}
			/>
		</div>
		${!dto.isOneWay
			? html`
					<div
						class=${classNames("flex-1 rounded-lg", {
							"p-[2px] bg-[#bfdeff]": dto.isSelectingReturn,
						})}
						@click=${dto.onSelectReturn}
					>
						<input
							readonly
							class=${classNames(
								"w-full cursor-default rounded-lg border border-solid px-3 py-[5px] text-base outline-hidden bg-white",
								"placeholder:text-base/none placeholder:text-[#c1c1c1]",
								{
									"border-[#7D93B2] border-2 text-n-blue": dto.isSelectingReturn,
									"border-n-blue text-n-blue": !dto.isSelectingReturn && dto.returnDate,
									"border-[#c1c1c1] text-[#c1c1c1]": !dto.isSelectingReturn && !dto.returnDate,
								}
							)}
							placeholder=${i18next.t("Fecha Vuelta")}
							value=${dto.returnDate ? capitalizeAndRemoveDot(dto.returnDate.format("ddd DD-MM")) : ""}
						/>
					</div>
			  `
			: ""}
	</div>
`;
